import { useEffect, useState } from "react"
import { getRef, setRef } from "views/utils/InputHelp";
import { checkNumberMinus } from "views/utils/Validation";

interface IFProps {
    counterRef: React.RefObject<HTMLInputElement>,
    changeEvent: any,
    serviceIdx: number,
    optionIdx?: number,
    unit?: string,
    parentCounterRef?: React.RefObject<HTMLInputElement>,
    initCount?: number,
}

export function InputCounter(props: IFProps){

    const [errMsg, setErrMsg] = useState("");
    let addDisabled = false;
    let removeDisabled = false;
    let counterDisabled = false;

    //-------------------------------------------------
    //ボタンの活性非活性判定
    //-------------------------------------------------
    if (props.parentCounterRef && Number(getRef(props.parentCounterRef)) < 1){
        //オプションの場合、親が0の場合は＋－非活性・カウントを0にする
        removeDisabled = true;
        addDisabled = true;
        counterDisabled = true;
        setRef(props.counterRef, "0");
    } else {
        //－ボタン
        if (Number(getRef(props.counterRef)) > 0){
            removeDisabled = false;
        } else {
            removeDisabled = true;
        }
        //＋ボタン
        if (Number(getRef(props.counterRef)) < 100){
            addDisabled = false;
        } else {
            addDisabled = true;
        }
        counterDisabled = false;
    }

    //-------------------------------------------------
    //イベント処理
    //-------------------------------------------------
    useEffect(function(){
        if (props.initCount){
            setRef(props.counterRef, props.initCount.toString());
            props.changeEvent(props.serviceIdx, props.optionIdx);
        } else {
            setRef(props.counterRef, "0");
        }
    }, []);
    
    useEffect(function(){
        if (props.initCount){
            setRef(props.counterRef, props.initCount.toString());
            props.changeEvent(props.serviceIdx, props.optionIdx);
        }
    }, [props.initCount]);

    function clickAdd(){
        setErrMsg("");
        let numVal = Number(getRef(props.counterRef));
        if (numVal < 100){
            setRef(props.counterRef, (numVal + 1).toString());
        }
        props.changeEvent(props.serviceIdx, props.optionIdx);
    }

    function clickRemove(){
        setErrMsg("");
        let numVal = Number(getRef(props.counterRef));
        if (numVal >= 1){
            setRef(props.counterRef, (numVal - 1).toString())
        }
        props.changeEvent(props.serviceIdx, props.optionIdx);
    }

    function changeCounter(){
        setErrMsg("");
        if (Number(getRef(props.counterRef)) < 0){
            setRef(props.counterRef, "0");
            setErrMsg("0より小さい値は入力できません。");
        }
        if (Number(getRef(props.counterRef)) > 100){
            setRef(props.counterRef, "100");
            setErrMsg("100より大きい値は入力できません。");
        }
        let errmsg = checkNumberMinus(getRef(props.counterRef), "");
        if (errmsg){
            setRef(props.counterRef, "0");
            setErrMsg("数字を入力してください。");
        }
        props.changeEvent(props.serviceIdx, props.optionIdx);
    }

    return (
        <>
            {errMsg && <p className="order-item-control-msg">{errMsg}</p>}
            <button className="order-item-control-minus" onClick={clickRemove} disabled={removeDisabled}><span className="material-icons-round">remove</span></button>
            <input type="tel" maxLength={3} className="order-item-control-count input-size-sss text-right" disabled={counterDisabled} ref={props.counterRef} onChange={changeCounter}/>{props.unit && <span className="order-item-unit">{props.unit}</span>}
            <button className="order-item-control-plus" onClick={clickAdd} disabled={addDisabled}><span className="material-icons-round">add</span></button>
        </>
    )

}
